/**
 * User-facing names for activity logs.
 * Long: page titles, permissions. Medium: pane / set headers. Short: nav, buttons.
 */
export const ACTIVITY_LOGS_LABEL_LONG = 'Activity logs';
export const ACTIVITY_LOGS_LABEL_MEDIUM = 'Activity';
export const ACTIVITY_LOGS_LABEL_SHORT = 'Logs';

export const LOG_TYPE_DEFAULT = 'Activity';
export const LOG_TYPE_DELETED = 'Log deleted';
export const LOG_TYPE_CHANGE = 'Log change';
export const LOG_TYPE_RESTORED = 'Log restored';

/** Chart / set header — "Activity 1". */
export const activitySetChartsLabel = (serial: number): string => (
  `${ACTIVITY_LOGS_LABEL_MEDIUM} ${Math.max(1, Math.floor(Number(serial) || 1))}`
);

const normType = (type: string | null | undefined): string => String(type || '').trim();

/** Default log type, including rows still stored as Audit. */
export const isDefaultActivityType = (type: string | null | undefined): boolean => {
  const t = normType(type);
  return !t || t === LOG_TYPE_DEFAULT || t === 'Audit';
};

/** Restore keys off this — accept old Audit / Activity deleted labels. */
export const isLogDeletedType = (type: string | null | undefined): boolean => {
  const t = normType(type);
  return t === LOG_TYPE_DELETED || t === 'Audit deleted' || t === 'Activity deleted';
};

export const isLogChangeType = (type: string | null | undefined): boolean => {
  const t = normType(type);
  return t === LOG_TYPE_CHANGE || t === 'Audit change' || t === 'Activity change';
};

export const isLogRestoredType = (type: string | null | undefined): boolean => {
  const t = normType(type);
  return t === LOG_TYPE_RESTORED || t === 'Audit restored' || t === 'Activity restored';
};

/** Display stored log types, including older Audit labels. */
export const displayActivityLogType = (type: string | null | undefined): string => {
  const t = normType(type);
  if (isDefaultActivityType(t)) return ACTIVITY_LOGS_LABEL_MEDIUM;
  if (isLogDeletedType(t)) return LOG_TYPE_DELETED;
  if (isLogChangeType(t)) return LOG_TYPE_CHANGE;
  if (isLogRestoredType(t)) return LOG_TYPE_RESTORED;
  if (t === 'Active audits' || t === 'Active audits2' || t === 'Active logs') return 'Active logs';
  if (t === 'All audits' || t === 'All logs') return 'All logs';
  return t;
};
